"use client";
import HomePoojas from "@/components/HomePoojaComponents/FeaturePoojas";
import TestmonialComponent from "@/components/TestimonialComponent/TestimonialComponent";
import PoojaServices from "@/components/HomePoojaComponents/PoojaServicesComponent";
import PoojasComponent from "@/components/HomePoojaComponents/PoojasComponent";
import CategoriesComponent from "@/components/HomePoojaComponents/CategoriesComponent";
import DeitiesComponent from "@/components/HomePoojaComponents/DeitiesComponent";
import {
    BACKEND_API_ROUTE,
    GET_LANDING_PAGE_ROUTE,
} from "@/commons/api_routes";
import { GETREQUESTAPI } from "../../api/apiUtils";
import HeroSection from "@/components/HeroSectionComponent/HeroSection";
import React, { useEffect } from "react";
import { getCookieItem, removeCookieItem } from "@/utils/utils";
import { useRouter } from "next/router";
import Head from "next/head";
import {getPageSEO} from "@/pages/api";
import {DEFAULT_SEO_VALUES} from "@/commons/constants";

export default function Home({ data , seoData}) {
    const router = useRouter();

    useEffect(() => {
        router.push('/')
        window.scrollTo(0, 0);
    }, []);
    const { allPoojaItems, dietySubCategories, featuredPooja, poojaCategories } =
        data.body;

    const PoojaByLanguageData = {
        title: "Featured Poojas",
        titleImage: "/icons/Group6726.svg",
        boxHeight: 168,
        boxWidth: 168,
        boxesData: featuredPooja,
    };
    const servicesSectionData = {
        title: "Your One-Stop Destination for Hassle-Freee Pooja Booking",
        boxesData: [
            {
                id: 17,
                imageUrl: "/images/Pooja_Services.jpg",
                altText: "Pooja Services",
            },
            {
                id: 18,
                imageUrl: "/images/Temple_Services.jpg",
                altText: "Temple Services",
            },
        ],
    };
    const categoriesPoojaSectionData = {
        title: "Browse Pooja By Category",
        titleImage: "/icons/Group6726.svg",
        boxesData: poojaCategories,
    };
    const DeitiesSectionData = {
        title: "Browse Pooja By Deities",
        titleImage: "/icons/Group6726.svg",
        boxesData:
            dietySubCategories.length > 0 ? dietySubCategories[0].subCategories : [],
    };
    const poojaSectionData = {
        title: "Browse All Poojas",
        titleImage: "/icons/Group6728.svg",
        boxHeight: 260,
        boxWidth: 356,
        boxesData: allPoojaItems,
    };
    useEffect(() => {
        const redirectUrl = getCookieItem("redirectUrl"); 
        if (redirectUrl) {
            removeCookieItem("redirectUrl");
            router.push(redirectUrl);
        }
    });

    //Demo data for SEO in case of cms issues handling
    const seoDemoDataMap = {
        "hindi-bangalore": {
            seoTitle: "Book Verified Pandits Online in Bangalore | Book My Pooja",
            seoDescription: "Book verified Pandits online in Bangalore for authentic rituals and ceremonies. Enjoy hassle-free pooja services with easy online booking at BookMyPooja.",
            seoKeywords: "online pooja booking,pooja pandit services,pooja booking,online puja services,book pandit online,pooja booking online"
        },
        "kannada-bangalore": {
            seoTitle: "Book Verified Purohiharu in Bangalore | Pooja Services | BookMyPooja",
            seoDescription: "Book verified Kannada speaking Purohiharu in Bangalore for authentic rituals. Experience reliable and hassle-free pooja services with BookMyPooja.",
            seoKeywords: "online pooja booking,pooja pandit services,pooja booking,online puja services,book pandit online,pooja booking online"
        },
        "malayalam-bangalore": {
            seoTitle: "Book Verified Malayali Poojari in Bangalore | Book My Pooja",
            seoDescription: "Book a verified Malayali Poojari in Bangalore for authentic rituals, pooja, and ceremonies. Trusted services with easy online booking at BookMyPooja.",
            seoKeywords: "online pooja booking,pooja pandit services,pooja booking,online puja services,book pandit online,pooja booking online"
        }
    };
    const {location, language} = router.query;
    const key = `${language}-${location}`.toLowerCase();
    // Hand-written overrides win, then CMS data, then the site-wide defaults
    const seoDemoData = seoDemoDataMap[key] || {};
    const seoTitle = seoDemoData.seoTitle || seoData?.body?.title || DEFAULT_SEO_VALUES.title;
    const seoDescription = seoDemoData.seoDescription || seoData?.body?.description || DEFAULT_SEO_VALUES.description;
    const seoKeywords = seoDemoData.seoKeywords || seoData?.body?.keywords || DEFAULT_SEO_VALUES.keywords;
    const canonical = process.env.NEXT_PUBLIC_SITE_URL+router.asPath;
    return (
        <>
            <Head>
                <meta
                    name="google-site-verification"
                    content="Ttzt19k6OKEURdkJsmR_pHJbQPtd3fHL8uatwstkSAk"
                />
                <title>{seoTitle}</title>
                <meta name="description" content={seoDescription} />
                <link rel="canonical" href={canonical}/>
                <meta name="keywords" content={seoKeywords}/>
                <meta
                    property="og:image"
                    content="https://seo-b.s3.ap-south-1.amazonaws.com/logo.jpeg"
                />
                <meta
                    name="image"
                    content="https://seo-b.s3.ap-south-1.amazonaws.com/logo.jpeg"
                />
                <meta property="og:title" content={seoTitle}/>
                <meta property="og:description" content={seoDescription}/>
                <meta property="og:type" content="website"/>
                <meta property="og:keywords"
                        content={seoKeywords}/>

            </Head>
            <div>
                {/*<HeroSection/>*/}
                {/*<HomePoojas data={PoojaByLanguageData}/>*/}
                {/*<PoojaServices data={servicesSectionData}/>*/}
                {/*<CategoriesComponent data={categoriesPoojaSectionData}/>*/}
                {/*<DeitiesComponent data={DeitiesSectionData}/>*/}
                {/*<PoojasComponent data={poojaSectionData}/>*/}
                {/*<TestmonialComponent/>*/}
            </div>
        </>
    );
}

export const getServerSideProps = async (context) => {
    const { params } = context;
    const location = params.location;
    const language = params.language;
    const locationQuery = location ? `location=${location}` : "";
    const languageQuery = language ? `language=${language}` : "";
    let query = "?";
    if (locationQuery && languageQuery) {
        query += `${locationQuery}&${languageQuery}&`;
    }

    const homePageUrl = BACKEND_API_ROUTE + GET_LANDING_PAGE_ROUTE + query;
    const response = await GETREQUESTAPI(homePageUrl);
    const data = await response.data;
    const seoResponse = await getPageSEO('home');
    const seoData = await seoResponse.data;
    return { props: { data , seoData } };
};
